export const isEmbeddedInIFrame = window !== window.parent && !window.opener;
